/* eslint-disable */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Button from "components/CustomButtons/Button.js";

const useStyles = makeStyles({
  bgImage: {
    backgroundImage: `url('/500.jpg')`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    minHeight: '100vh',
    minWidth: '100vw',
    // backgroundRepeat: "no-repeat",
  }
});

export default function Page404(props) {
  const classes = useStyles();
  return (
    <Box display='flex' alignItems='center' className={classes.bgImage}>
      <Grid container spacing={0} alignContent='center' direction='column' className={classes.grid}>
        <div>
          <h1 className="float-left display-3 mr-4">404</h1>
          <h4 className="pt-3">Oops! You're lost.</h4>
          <p className="text-muted float-left">The page you are looking for was not found.</p>
        </div>
        <Button color="primary" onClick={()=>window.location.href="/"}> Back to home</Button>
      </Grid>
    </Box>
  )
}